import React from "react";
// COMPONENTS
import MonitoringLiftTopView from "./MonitoringLiftTopView";
// INTERFACES
import { BankInterface } from "../../../interfaces/Bank.interface";
import { LiftInterface } from "../../../interfaces/Lift.interface";
// UTILS
import { hasMixedDoorConfig } from "../../../utils/bitmaskToIcon";

function MonitoringTopView({
  bank,
  serverId,
  channelId,
}: {
  bank: BankInterface;
  serverId: string;
  channelId: string;
}) {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */

  // ************************************************ */
  // USE STATE VARIABLES **************************** */

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */

  // ************************************************* */
  // USE EFFECT ************************************** */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div className="generalStyles__flex" style={{ justifyContent: "center" }}>
      {(bank.lifts ?? [])
        .slice() // Create a shallow copy to avoid mutating the original array
        .sort((a: LiftInterface, b: LiftInterface) => {
          // Compare values based on a specific property (e.g., lift.name)
          if (a.position < b.position) return -1;
          if (a.position > b.position) return 1;
          return 0;
        })
        .map((lift: LiftInterface) => (
          <div key={String(lift.id)}>
            <MonitoringLiftTopView
              lift={lift}
              bank={bank}
              serverId={serverId}
              channelId={channelId}
              bankHasMixedDoors={hasMixedDoorConfig(lift.liftFloors)}
            />
          </div>
        ))}
    </div>
  );
}

export default React.memo(MonitoringTopView);
